// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"33ed3ff5","61":"160ea35f","73":"fac88fc9","686":"ce1c9b0a","751":"eb21807d"}[chunkId] + ".chunk.js";
};